export class PodcastClip {
  id: string;
  url: string;
  clickThroughUrl: string;

  seriesName: string;
  episodeName: string;
  channelLanguage: string;
  channelImage: string;
  itemTitle: string;
  audioUrl: string;
  imageUrl: string;
  enabled: boolean;
  itemDurationSec: number;
}

export class RSSFeed {
  id: string;
  url: string;
  name: string;
  enabled: boolean;
}
